import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { isNotNullOrUndefined } from '@weft/utils';
import dayjs from 'dayjs';
import type { Control, FieldPath } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { UpdateContractForm } from '../ContractUpdateForm';

type SaveContractDatePickerProps = {
  control: Control<UpdateContractForm>; 
  name: FieldPath<UpdateContractForm>;
};
  
export const SaveContractDatePicker: React.FC<SaveContractDatePickerProps> = ({ control, name }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <DatePicker
          value={dayjs(field.value).utc(false)}
          onChange={(newDate) => {
            if (isNotNullOrUndefined(newDate)) {
              field.onChange(newDate.utc(false).toDate());
            }
          }}
          slotProps={{
            textField: {
              fullWidth: true,
              sx: {
                '& .MuiOutlinedInput-root': {
                  background: '#F4FBFF',
                  borderRadius: '8px',
                  paddingLeft: '8px',
                  '& fieldset': {
                    borderColor: '#EAF2F7',
                  },
                  '&:hover fieldset': {
                    borderColor: '#EAF2F7',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#EAF2F7',
                  },
                },
                '& .MuiSvgIcon-root': {
                  color: '#588DF7',
                },
              },
            },
          }}
        />
      )}
    />
  );
};